import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import { useConversion } from "../context/BookingContext";
import { BUSINESS } from "../data";

const LINKS = [
  { label: "Work", href: "#gallery" },
  { label: "Services", href: "#services" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const { openBooking, openQuote } = useConversion();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${scrolled ? "backdrop-blur-xl bg-black/60 border-b border-white/10" : "bg-transparent"}`}
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo" className="flex items-center gap-2 group">
          <span className="w-2 h-2 bg-[#FF3B30] group-hover:rotate-45 transition-transform duration-300" />
          <span className="font-display font-bold uppercase tracking-tight text-sm md:text-base leading-none">
            Adelaide Premium<br className="hidden md:block" /> Detailing
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm text-zinc-300 hover:text-white transition-colors relative group">
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#FF3B30] group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <Button
            data-testid="cta-book-service-header"
            onClick={() => openBooking()}
            variant="outline"
            className="rounded-none border-white text-white bg-transparent hover:bg-white hover:text-black font-display uppercase tracking-widest text-xs h-10"
          >
            Book a Service
          </Button>
          <Button
            data-testid="cta-get-quote-header"
            onClick={() => openQuote()}
            className="rounded-none bg-[#FF3B30] hover:bg-[#D63026] text-white font-display uppercase tracking-widest text-xs h-10"
          >
            Get a Quote
          </Button>
        </div>

        <button className="md:hidden text-white" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {mobileOpen ? <X /> : <Menu />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-black border-t border-white/10 px-5 py-6 space-y-4" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setMobileOpen(false)} className="block font-display uppercase tracking-wide text-lg">{l.label}</a>
          ))}
          <div className="flex flex-col gap-3 pt-4">
            <Button onClick={() => { openBooking(); setMobileOpen(false); }} variant="outline" className="rounded-none border-white bg-transparent text-white font-display uppercase tracking-widest">Book a Service</Button>
            <Button onClick={() => { openQuote(); setMobileOpen(false); }} className="rounded-none bg-[#FF3B30] text-white font-display uppercase tracking-widest">Get a Quote</Button>
          </div>
        </div>
      )}
    </header>
  );
}
